import { GridPostParams, GridModel } from "common/models/utility-models/list-utility.model";
import { CompanyLocationModel } from "./company-location-data.model";

export class CompanyLocationGridParams extends GridPostParams {
    internshipCompanyId: any = 117;
  }
  export class CompanyLocationGridModel extends CompanyLocationModel {}
  
  export class CompanyLocationListingModel extends GridModel<CompanyLocationGridModel> {}